import React from 'react';
import {
  FDStack,
  FDPaper,
} from '@facet-wealth/design';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';
import { TaxDiagnosticWrapperLayout } from 'Views/Page/Content/Templates/TaxDiagnosticCommon/TaxDiagnosticWrapperLayout';
import { dataAttrs } from 'Helpers/Testing';
import DescriptionImagePicker from './DescriptionImagePicker/DescriptionImagePicker';

const Layout = () => {
  useBoneBackgroundColor();
  const isMobile = useMobileLayout();

  const { resource } = useMetaLayoutContext();

  return (
    <TaxDiagnosticWrapperLayout>
      <FDPaper appearance={'elevated'} overflow={'hidden'}>
        <FDStack direction={isMobile ? 'column' : 'row'}>
          <FDStack direction={'column'} spacing={3} padding={3} flex={1}>
            <MetaControlField attr="header" />
            <MetaControlField attr="title" {...dataAttrs('intro-step-title')} />
            <MetaControlField attr="description" />
          </FDStack>
          <FDStack flex={1}>
            <DescriptionImagePicker resource={resource} />
          </FDStack>

        </FDStack>
      </FDPaper>
    </TaxDiagnosticWrapperLayout>
  );
};

Layout.defaultProps = {
};

Layout.propTypes = {
};

export default Layout;
